<template>
  <div>
    <div id="footer">
      <div class="inner_static">
        <ul id="fnb">
          <li class="ls1">
            <a class="btn_terms" @click="btnTermsClick()">利用規約</a>
          </li>
          <li class="ls2">
            <a class="btn_privacy" @click="btnPrivacyClick()">プライバシーポリシー</a>
          </li>
          <li class="ls3">
            <a @click="btnContactClick()">お問い合わせ</a>
          </li>
        </ul>
      </div>
    </div>
    <kg-terms />
    <kg-privacypolicy />
  </div>
</template>

<script>
import Terms from '../common/Terms'
import PrivacyPolicy from '../common/PrivacyPolicy'

export default {
  components: {
    'kg-terms': Terms,
    'kg-privacypolicy': PrivacyPolicy
  },
  props: {
    toContactEventFlg: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    btnTermsClick: function (event) {
      // 利用規約クリック時の処理
      if (event) {
        event.preventDefault()
      }
      var scrollpos = 0
      var terms = document.getElementById('terms')
      var bodyElements = document.getElementsByTagName('body')
      if (terms.classList.contains('open')) {
        terms.classList.remove('open')
        bodyElements[0].classList.remove('fixed')
        bodyElements[0].style.top = 0
        window.scrollTo(0, scrollpos)
      } else {
        terms.classList.add('open')
        scrollpos = window.scrollTop
        bodyElements[0].classList.add('fixed')
        bodyElements[0].style.top = -scrollpos
      }
    },
    btnPrivacyClick: function (event) {
      // プライバシーポリシークリック時の処理
      if (event) {
        event.preventDefault()
      }
      var scrollpos = 0
      var terms = document.getElementById('privacy')
      var bodyElements = document.getElementsByTagName('body')
      if (terms.classList.contains('open')) {
        terms.classList.remove('open')
        bodyElements[0].classList.remove('fixed')
        bodyElements[0].style.top = 0
        window.scrollTo(0, scrollpos)
      } else {
        terms.classList.add('open')
        scrollpos = window.scrollTop
        bodyElements[0].classList.add('fixed')
        bodyElements[0].style.top = -scrollpos
      }
    },
    btnContactClick: function () {
      if (this.toContactEventFlg) {
        this.$emit('toContactEvent')
        return
      }
      this.$router.push('/kagull/support/input/0')
    }
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/components/login/LoginFooter.vue